import React, { useState, useEffect } from "react";
import { Column, Row, Text, Icon } from "@amzn/meridian";
import { useNavigate } from "react-router-dom";
import { useAppSelector, useAppDispatch } from "src/store/store";
import { COLORS } from "src/constants/colors";
import chevronLeftLargeTokens from "@amzn/meridian-tokens/base/icon/chevron-left-large";
import StepRenderer from "./StepRenderer";
import { setCurrentStep } from "src/store/workflowSlice";
import { resetInspectionCaptureState } from "src/store/inspectionCaptureSlice";

const WorkflowExecutor = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const {
    inspectionWorkflow,
    showWorkflowHeader,
    currentStep,
    shownHumanText,
    currentIterationIndex,
    totalIterations,
    inspectionId
  } = useAppSelector((state) => state.workflow);
  const [currentCategoryIndex, setCurrentCategoryIndex] = useState(0);
  const [currentStepIndex, setCurrentStepIndex] = useState(0);
  const [drumCount, setDrumCount] = useState<number | null>(null);

  // Check if we're currently in an iterate step
  const isInIterateStep = currentStep && 'iterate' in currentStep && totalIterations > 0;

  if (!inspectionWorkflow) {
    return (
      <Column height="100vh" alignmentVertical="center" alignmentHorizontal="center">
        <Text type="h200">Loading workflow...</Text>
      </Column>
    );
  }
  useEffect(() => {
    dispatch(setCurrentStep(inspectionWorkflow.categories[0]?.steps[currentStepIndex]))
  }, []);

  const currentCategory = inspectionWorkflow.categories[currentCategoryIndex];

  const handleStepComplete = (data?: any) => {
    // If this was a drum count step, store the count
    if (data?.drumCount !== undefined) {
      setDrumCount(data.drumCount);
    }

    // Move to next step
    if (currentStepIndex < currentCategory.steps.length - 1) {
      dispatch(setCurrentStep(inspectionWorkflow.categories[0]?.steps[currentStepIndex + 1]));
      setCurrentStepIndex(currentStepIndex + 1);
    } else if (currentCategoryIndex < inspectionWorkflow.categories.length - 1) {
      // Move to next category
      setCurrentCategoryIndex(currentCategoryIndex + 1);
      setCurrentStepIndex(0);
    } else {
      // Workflow complete - navigate to review page
      navigate(`/configurationDrivenInspections/${inspectionId}/review`);
    }
  };

  return (
    <Column
      height="100vh"
      backgroundColor={COLORS.VERY_DARK_GRAY}
      alignmentVertical="justify"
      className="inspection-page"
    >
      {/* Header */}
      {showWorkflowHeader && <Column
        width="100%"
        spacingInset="600 500 400"
        className="inspection-info-wrapper"
      >
        <Row>
          <div
            style={{ cursor: "pointer", marginLeft: "50px" }}
            onClick={() => {
              dispatch(resetInspectionCaptureState());
              navigate("/configurationDrivenInspections")
            }}
          >
            <Icon tokens={chevronLeftLargeTokens} color="inverted" />
          </div>
          <Text color="inverted" type="h200">{currentCategory.human_text}</Text>
        </Row>
        <Column spacing={"300"}>
          <Row spacingInset={"200 none"}>
            <Text color="inverted">{shownHumanText}</Text>
          </Row>
          {/* Drum counter - only show when in iterate step */}
          {isInIterateStep && (
            <Row spacingInset={"200 none"} alignmentHorizontal="center">
              <Text color="inverted" type="h300">
                Drum {currentIterationIndex + 1} of {totalIterations}
              </Text>
            </Row>
          )}
        </Column>
      </Column>}


      {currentStep !== null && <StepRenderer
        step={currentStep}
        drumCount={drumCount}
        onStepComplete={handleStepComplete}
      />}

    </Column>
  );
};

export default WorkflowExecutor;